import Hamburger from './Hamburger'
import AnchorScroll from './AnchorScroll'
import LangChanger from './LangChanger'
// import ScrollFollowNavigation from './ScrollFollowNavigation'

export default class {
  constructor() {
    // smoothscroll.polyfill();

    const domHamburger = document.querySelector('[data-js="trigger"]');
    if (domHamburger) new Hamburger(domHamburger);

    const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    if ( domAnchorScroll ) {
      domAnchorScroll.forEach(el => {
        new AnchorScroll(el);
      });
    }

    const domLangChanger = document.querySelectorAll('[data-js="lang"]');
    if (domLangChanger) new LangChanger(domLangChanger);
  }
}
